import React from 'react';
import { useSelector } from 'umi';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import "./index.scss";
import { pcPageConfig } from './pcPageConfig';

const reqParams = '/realtime/steamCCU';
const RealtimeSteamCCU = () => {
  const dataFrame = useSelector((state: any) => state?.dashboard?.currentGame?.data_frame || 'mobile');
  const pageMap: any = {
    pc: pcPageConfig,
  };
  return (
    <div className='dbd-realtime-steam-ccu-container'>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]} />
    </div>
  );
};

export default RealtimeSteamCCU;